export function DispatchSetLoading(dispatch: any, loading: boolean) {
  dispatch({ type: "@UI/SET_LOADING", payload: loading });
}
